import { render, staticRenderFns } from "./BatchFileTab.vue?vue&type=template&id=4232522f"
import script from "./BatchFileTab.vue?vue&type=script&lang=js"
export * from "./BatchFileTab.vue?vue&type=script&lang=js"
import style0 from "./BatchFileTab.vue?vue&type=style&index=0&id=4232522f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports